import { render } from "./BuyCoin.vue?vue&type=template&id=03e4cb16&scoped=true"
import script from "./BuyCoin.vue?vue&type=script&lang=js"
export * from "./BuyCoin.vue?vue&type=script&lang=js"

import "./BuyCoin.vue?vue&type=style&index=0&id=03e4cb16&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e4cb16"]])

export default __exports__